'use client';
import HeadlessModal from '@/components/shared/HeadlessModal';
import Image from 'next/image';
import useCountrySelection from '@/hooks/useCountrySelection';

const CountrySelectModal = () => {
  const { selected, setCountryToCookie } = useCountrySelection();

  return (
    <HeadlessModal
      isOpen={!selected}
      closeModal={() => false}
      dialogPanelClassName="!w-[350px] sm:!w-[372px] !min-h-min !rounded-[10px]"
      dialogCloseBtnClassName="!hidden"
      dialogWrapClassName="!items-start !pt-[24px] sm:!pt-[88px]"
    >
      <h4 className="text-center text-h7 font-[700] text-title">
        Which country do you like to visit?
      </h4>
      <ul className="flex items-center justify-center gap-8">
        <li
          onClick={() => setCountryToCookie('DE')}
          className="mt-[22px] cursor-pointer text-center"
        >
          <Image
            src={'/germany-dialog.png'}
            alt={'Germany'}
            width={50}
            height={33.3333}
            className="mx-auto h-[33.3333px] w-[50px]"
          />
          <span className="mt-2 inline-block text-xs text-title">Germany</span>
        </li>
        <li
          onClick={() => setCountryToCookie('AT')}
          className="mt-[22px] cursor-pointer text-center"
        >
          <Image
            src={'/aus-dialog.png'}
            alt={'Austria'}
            width={50}
            height={33.3333}
            className="mx-auto h-[33.3333px] w-[50px]"
          />
          <span className="mt-2 inline-block text-xs text-title">Austria</span>
        </li>
        <li
          onClick={() => setCountryToCookie('CH')}
          className="mt-[22px] cursor-pointer text-center"
        >
          <Image
            src={'/switzerland-dialog.png'}
            alt={'Switzerland'}
            width={50}
            height={33.3333}
            className="mx-auto h-[33.3333px] w-[50px]"
          />
          <span className="mt-2 inline-block text-xs text-title">
            Switzerland
          </span>
        </li>
      </ul>
    </HeadlessModal>
  );
};

export default CountrySelectModal;
